export const employeesNumber = [
	{ value: '1-20', label: '1-20 employees' },
	{ value: '21-50', label: '21-50 employees' },
	{ value: '51-100', label: '51-100 employees' },
	{ value: '101-500', label: '101-500 employees' },
	{ value: '501-1000', label: '501-1000 employees' },
	{ value: '1000+', label: '1000+ employees' },
];
